var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tabs',_vm._g(_vm._b({staticClass:"hb-tabs-wrapper",attrs:{"background-color":_vm.backgroundColor,"color":_vm.color,"show-arrows":_vm.showArrows,"slider-color":_vm.sliderColor},model:{value:(_vm.vmodel),callback:function ($$v) {_vm.vmodel=$$v},expression:"vmodel"}},'v-tabs',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }